import {
  ActionSheetButton,
  ActionSheetController,
  Content,
  IonicPage,
  NavParams,
} from 'ionic-angular';
import { Component, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs';

import {
  FillerMessageTypes,
  fillerMessageConfirmation,
  fillerServiceLabels,
} from '../../providers/message/message';
import { LoadingAlertProvider } from './../../providers/loading-alert/loading-alert';
import { MessageModel } from '../../models/message';
import { OpsOrderModel } from '../../models/order.ops';
import { OpsProvider } from '../../providers/ops/ops';

@IonicPage()
@Component({
  selector: 'page-user-messages',
  templateUrl: 'user-messages.html',
})
export class UserMessagesPage {
  @ViewChild('content') content: Content;

  messages$: Observable<MessageModel[]>;
  order: OpsOrderModel;
  messageCount: number;
  onMessageSend: Function;

  provider = false;

  private unsubscribe: Subject<void> = new Subject();

  constructor(
    navParams: NavParams,
    private actionCtrl: ActionSheetController,
    private opsService: OpsProvider,
    private loadingAlert: LoadingAlertProvider
  ) {
    this.provider = navParams.get('provider');
    this.messages$ = navParams.get('messages$');
    this.onMessageSend = navParams.get('onMessageSend');

    this.order = navParams.get('order');

    this.getMessages();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UserMessagesPage');
  }

  ionViewDidEnter() {
    this.content.scrollToBottom(300);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // Actions

  didTapSendMessage() {
    const msgOptionHandler = (type: FillerMessageTypes) => {
      this.shouldSendMessage(type)
        ? this.showMessageSentToast()
        : this.showConfirmation(type);
    };
    const buttons: ActionSheetButton[] = Object.keys(fillerServiceLabels).map(
      (key: FillerMessageTypes) => {
        const value = fillerServiceLabels[key];
        return {
          text: value,
          handler: () => msgOptionHandler(key),
        };
      }
    );
    buttons.push({
      text: 'Cancel',
      role: 'cancel',
    });
    const actionSheet = this.actionCtrl.create({ buttons });
    actionSheet.present();
  }

  showConfirmation(type: FillerMessageTypes) {
    const label = fillerMessageConfirmation[type];
    this.loadingAlert.showConfirmationDialog(
      `Are you sure you want to send a ${label} message? You can only send one of these per order.`,
      `Send`,
      () => this.sendMessage(type)
    );
  }

  // Data

  getMessages() {
    this.messages$.takeUntil(this.unsubscribe).subscribe(messages => {
      if (messages && this.content && messages.length != this.messageCount) {
        setTimeout(() => this.content && this.content.scrollToBottom(300), 100);
      }
      this.messageCount = messages.length;
    });
  }

  sendMessage(fillerMessageType: FillerMessageTypes) {
    this.loadingAlert.showLoader();
    this.opsService
      .sendMessageForOrder(this.order, fillerMessageType)
      .finally(() => this.loadingAlert.dismissLoader())
      .subscribe(
        () => {
          this.onMessageSend && this.onMessageSend();
          this.loadingAlert.showToastConfirmation(
            'Message sent. Please wait 5-10 minutes for the customer to come out.'
          );
        },
        error => {
          this.loadingAlert.showToastAlert('Error sending message');
        }
      );
  }

  // Helpers

  shouldSendMessage(fillerMessageType: FillerMessageTypes) {
    return this.opsService.didSendMessageForOrder(
      this.order,
      fillerMessageType
    );
  }

  private showMessageSentToast() {
    this.loadingAlert.showToastConfirmation('Message already sent!');
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-messages/user-messages.ts